import React from 'react';
import { TILE_STATUS } from '../game/constants';
import { gameState } from '../game/state/GameState';

const AXIS_ACCENT = { x: '#c4a484', y: '#6faf7a', z: '#e8772a' };

/** Compact slice chip — tap to select (hub claims via Confirm bar). */
const TileNodeV2 = ({
  tile,
  selected = false,
  onSelectSlice,
  onHoverSlice,
  disabled = false,
  highlighted = false,
  dimmed = false,
}) => {
  const isOwner = tile.claimedBy === gameState.currentUser?.id;
  const axis = tile.data?.axis;
  const index = tile.data?.index;
  const label =
    axis != null ? `${String(axis).toUpperCase()}${index}` : tile.data?.clue || '?';

  let stateClass = 'state-open';
  if (tile.status === TILE_STATUS.SOLVED) stateClass = 'state-solved';
  else if (tile.status === TILE_STATUS.CLAIMED) {
    stateClass = isOwner ? 'state-claimed-me' : 'state-claimed-other';
  }

  const accent = AXIS_ACCENT[axis] || '#7d8a99';
  const lockedOut =
    disabled || (tile.status === TILE_STATUS.CLAIMED && !isOwner);

  const handleActivate = () => {
    if (lockedOut) return;
    if (axis != null) onHoverSlice?.({ axis, index });
    if (onSelectSlice) {
      onSelectSlice(tile);
      return;
    }
    // Legacy paths (bootcamp / vault grid)
    gameState.selectTile(tile.id);
  };

  return (
    <button
      type="button"
      className={`slice-chip ${stateClass}${selected ? ' is-selected' : ''}${
        highlighted ? ' is-guided-target' : ''
      }${dimmed ? ' is-dimmed' : ''}`}
      onClick={handleActivate}
      onPointerEnter={() => axis != null && onHoverSlice?.({ axis, index })}
      disabled={lockedOut}
      aria-pressed={selected}
      aria-label={`Slice ${label}${selected ? ', selected' : ''}${
        highlighted ? ', recommended' : ''
      }`}
      style={{ '--slice-accent': accent }}
    >
      <span className="slice-chip-label">{label}</span>
      {highlighted && tile.status === TILE_STATUS.OPEN && (
        <span className="slice-chip-badge slice-chip-badge--hint">Tap</span>
      )}
      {tile.status === TILE_STATUS.SOLVED && <span className="slice-chip-badge">✓</span>}
      {tile.status === TILE_STATUS.CLAIMED && isOwner && (
        <span className="slice-chip-badge">🔒</span>
      )}
    </button>
  );
};

export default TileNodeV2;
